module.exports = __webpack_public_path__ + "static/img/2.a3bce7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/2.png
// module id = cK4u
// module chunks = 0